import { render, staticRenderFns } from "./ModalInfoComplementar.vue?vue&type=template&id=0a8ba484&scoped=true"
import script from "./ModalInfoComplementar.vue?vue&type=script&lang=js"
export * from "./ModalInfoComplementar.vue?vue&type=script&lang=js"
import style0 from "./ModalInfoComplementar.vue?vue&type=style&index=0&id=0a8ba484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8ba484",
  null
  
)

export default component.exports